import Utility from "../../utils/Utilty";

/**
 * テーブル表示用にデータを成型
 * @param {*} rawReportData Recorderがresultで吐き出すデータ形式
 */
export const summrizeTableData = ((rawReportData) => {
  const meanMap = new Map(); // 平均値でソートするよう
  const forLine = []; // 折れ線グラフ用のデータ
  const forPreTable = new Map(); // テーブル集計のためのデータ

  rawReportData.forEach((frameData) => {
    const timestamp = frameData.timestamp;
    const typeFrameData = frameData.typeFrameData; // route type集計
    const nameFrameData = frameData.nameFrameData; // route name集計

    for (const [route_name,count] of frameData.nameFrameData){
      if (forPreTable.has(route_name)){
        const existingCounts = forPreTable.get(route_name); // 現在の値を取得
        existingCounts.push(count); // 配列に値を追加
        forPreTable.set(route_name, existingCounts); // 更新
      } else {
        forPreTable.set(route_name,[count]); // 初期化
      }
    }

    for (const [route_type,count] of frameData.typeFrameData){
      forLine.push({timestamp:timestamp, route_type: route_type, count: count}); // 折れ線グラフ用に格納
    }
  })

  // 平均値を算出して表示順をソート
  for (const[route_name,counts] of forPreTable){
    meanMap.set(route_name,Utility.calculateAverage(counts))
  }
  const sorted = Utility.sortMap(meanMap); // 平均値で降順にソート

  const forTable = [];
  let empty_route_names = []; // 観測できなかった路線
  for (const[route_name,average] of sorted){
    if (average !== 0 || average !== NaN){
      forTable.push({route_name: route_name, counts: forPreTable.get(route_name)});
    } else {
      empty_route_names.push(route_name); // 観測できなかった路線を記録
    }
  }

  // 観測対象としたが観測できなかった路線を折れ線グラフ用のデータから除く
  let cleanedForLine;
  if (empty_route_names.length !== 0){
    cleanedForLine = forLine.filter(item => !empty_route_names.includes(item.route_name));
  } else {
    cleanedForLine = forLine;
  }
  

  return {table: forTable, line: cleanedForLine};
});
